import styled from "styled-components";

import designSystemColors from "../../../styles";

export const LimitWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0rem 2rem;
  gap: 0.5rem;
`;

export const DescriptionWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0rem 2rem;
  gap: 0.5rem;
`;

export const LimitText = styled.span`
  color: ${designSystemColors.textDescription};
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
`;

export const InfomationsText = styled.span`
  color: ${designSystemColors.textDescription};
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
`;
